import React, { useState } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { useUID } from 'react-uid';

import {
  TitleSmallText,
  BodySmallText,
  FontColor,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import { Popover, Alignment } from '@prisjakt/ui/popover';
import OpenInNewIcon from 'mdi-react/OpenInNewIcon';

import { OfferLink, OfferStoreIconWrapper } from './styles';

import { BaseProps } from '../../types';

type Props = Pick<
  BaseProps,
  'name' | 'link' | 'highlightedName' | 'onClick' | 'store'
>;

export const CompactListCardOfferContent: React.FC<Props> = props => {
  const { name = '', highlightedName, link, onClick, store } = props;

  const { t } = useAppContext();
  const [showPopover, setShowPopover] = useState(false);
  const uid = useUID();

  const disabled = !onClick || !link;

  const handleClick = () => {
    if (disabled) {
      setShowPopover(true);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <div>
        <OfferLink
          isExternal
          to={disabled ? undefined : link || ''}
          target="_blank"
          rel="nofollow"
          onClick={handleClick}
          containerProps={{ 'aria-describedby': `offer-${uid}` }}
        >
          <TitleSmallText containerProps={{ 'data-test': 'OfferName' }}>
            {highlightedName ||
              (name.length > 100 ? `${name.substring(0, 100)}...` : name)}
            <div>
              <BodySmallText color={FontColor.DARK} emphasis={FontEmphasis.LOW}>
                {store && store.name}
              </BodySmallText>
              <OfferStoreIconWrapper>
                <OpenInNewIcon size={14} />
              </OfferStoreIconWrapper>
            </div>
          </TitleSmallText>
        </OfferLink>
      </div>

      {disabled && (
        <Popover
          id={`offer-${uid}`}
          visible={showPopover}
          width={250}
          offsetY={0}
          offsetX={0}
          verticalAlign={Alignment.Center}
          horizontalAlign={Alignment.Start}
          onClose={() => setShowPopover(false)}
          zIndex={20}
        >
          <BodySmallText>
            {t('product', 'transparency.store-info')}
          </BodySmallText>
        </Popover>
      )}
    </>
  );
};
